import { ComponentChildren } from 'preact';
import { useEsc } from 'client/utils/use-esc';
import { useRouter } from '@components/router';
import { RootUserMenu } from '@components/root-page-layout';
import { MenuItem } from '@components/dropdown';
import { useAuth } from 'client/lib/auth';

type Props = {
  children: ComponentChildren;
  isFullPage: boolean;
  currentStep: number;
  totalSteps: number;
  fadeDirection: string;
};

export function SignupWizard({
  children,
  isFullPage,
  currentStep,
  totalSteps,
  fadeDirection,
}: Props) {
  const router = useRouter();
  const auth = useAuth();

  const handleCancel = () => router.goto('/calendar/page-builder');

  useEsc(handleCancel, { escapeOnly: true });

  return (
    <div class="relative bg-gray-50 min-h-screen overflow-auto flex items-center py-8">
      <div
        class={`${isFullPage ? 'max-w-4xl' : 'max-w-lg p-8'} w-full bg-white rounded-2xl shadow-lg pb-16 mx-auto my-auto flex flex-col`}
      >
        <header class="flex-shrink-0">
          <div class="flex items-center justify-between">
            {!isFullPage && (
              <div class="font-semibold text-gray-900">
                Step {currentStep + 1} of {totalSteps}
              </div>
            )}

            {!isFullPage && auth.user && (
              <div class="ml-4">
                <RootUserMenu
                  renderMenu={() => (
                    <>
                      <MenuItem href="/calendar/settings">Settings</MenuItem>
                      <MenuItem href={`/logout?goto=${encodeURIComponent('/calendar/login')}`}>
                        Logout
                      </MenuItem>
                    </>
                  )}
                />
              </div>
            )}
          </div>
        </header>

        <main
          key={currentStep}
          class={`grow flex flex-col overflow-auto ${isFullPage ? '' : 'px-8'} ${fadeDirection}`}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
